<div class="card vx-shadow-hover text-center h-100">
  <div class="card-body p-2 bluebackground">
    <p class="card-title small mb-1 h5" [innerHTML]="pdf.pdfTitle"></p>
    <div class="pdfimg-container">
      <img class="img-fluid mx-auto pdfimg" [ngSrc]="pdf.pdfimg" alt="" [width]="pdf.width?pdf.width:'auto'" [height]="pdf.height?pdf.height:'auto'" loading="lazy">
    </div>
  </div>
  <div class="card-footer p-2 border-0 bluebackground">
    <div class="text-center btn-green w-100">
      <a class="py-2 text-white vx-cursor stretched-link" queryParamsHandling="merge" routerLink="/i"
        [queryParams]="{ comments: pdf.url }" [innerHTML]="pdf.opt | translate"></a>
    </div>
  </div>
</div>
